import BrProductCardV1 from './BrProductCardV1';
import * as Footers from './Footers';

BrProductCardV1.Footers = Footers;
export default BrProductCardV1;
